module.exports = __webpack_public_path__ + "static/media/girl-5.d488516b.svg";